<template>
    <div>
        <Modal size="sm" @close="$emit('close')">
            <template #header>
                <div class="text-topol-red-600">
                    {{ $t("vue.remove_integration_title") }}
                    {{ integrationType }} {{ $t("vue.integration") }}
                </div>
            </template>

            <template #body>
                <div
                    class="mb-4 mt-6 px-6 text-sm leading-normal text-gray-500"
                >
                    {{ $t("vue.you_are_about_to_remove") }}
                    {{ integrationType }} {{ $t("vue.integration") }}.
                    <br />
                    {{ $t("vue.do_you_wish_to_continue") }}
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        @click="$emit('close')"
                    >
                        {{ $t("vue.cancel") }}
                    </AtomicButton>
                    <AtomicButton
                        color="red"
                        size="md"
                        @click="$emit('remove')"
                    >
                        {{ $t("vue.remove_integration_button") }}
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
defineProps({
    integrationType: {
        type: String,
        required: true,
    },
});

defineEmits(["close", "remove"]);
</script>

<style></style>
